export default __webpack_public_path__ + "static/media/question-line.56c4f453.svg";